import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from 'semantic-ui-react'
import { css } from 'aphrodite'
import createStyles from './styles'

export class CenteredLayout extends React.PureComponent {
  render() {
    const { children, ...props } = this.props
    const styles = getStyles(props, this.context)

    return (
      <Grid textAlign="center" className={css(styles.root)}>
        <Grid.Column className={css(styles.main)} textAlign="left">
          {React.cloneElement(children, props)}
        </Grid.Column>
      </Grid>
    )
  }
}

CenteredLayout.contextTypes = {
  theme: PropTypes.object,
}

const getStyles = createStyles((props, context, theme) => ({
  root: {
    backgroundColor: theme.colors.background,
    height: '100%',
  },

  main: {
    margin: '90px auto 90px',
    maxWidth: props.maxWidth || 550,
  },
}))



// WEBPACK FOOTER //
// ./src/components/CenteredLayout.js